import { DealRoom } from 'models/DealRoom';

export type AnalyticsDealsTable = Pick<
  DealRoom,
  | 'name'
  | 'stage'
  | 'listing'
  | 'buyersSort'
  | 'filesSort'
  | 'ownerBusinessUnit'
  | 'ownerName'
  | 'successFeeShare'
  | 'colleaguesCount'
>;

export type AnalyticsDealsTableKeys = Array<keyof AnalyticsDealsTable>;

export const TABLE_COLUMNS: AnalyticsDealsTableKeys = [
  'name',
  'stage',
  'listing',
  'successFeeShare',
  'buyersSort',
  'filesSort',
  'ownerName',
  'ownerBusinessUnit',
  'colleaguesCount',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  name: 'deal',
  stage: 'stage',
  listing: 'listing',
  buyersSort: 'leads',
  filesSort: 'files',
  successFeeShare: 'successFee',
  colleaguesCount: 'headCount',
  ownerBusinessUnit: 'businessUnit',
  ownerName: 'owner',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  name: 'sortName',
  stage: 'sortStage',
  listing: 'hasListingSort',
  buyersSort: 'buyersSort',
  filesSort: 'filesSort',
  colleaguesCount: 'colleaguesCount',
  ownerBusinessUnit: 'ownerSortBusinessUnit',
  ownerName: 'ownerSortName',
  successFeeShare: 'successFeeShare',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  name: 400,
  stage: 120,
  listing: 50,
  buyersSort: 50,
  filesSort: 50,
  colleaguesCount: 50,
};
